import i18next from "i18next";
import { v4 as uuidv4 } from "uuid";

import { HttpMethodType } from "../http";

export default class HttpClient {
  protected static async request(
    token: string,
    url: RequestInfo,
    method: HttpMethodType,
    body?: BodyInit,
  ): Promise<Response> {
    if (token.length === 0) {
      throw new Error(i18next.t("api_error_msg.unauth"));
    }

    return fetch(url, {
      method,
      body,
      headers: {
        "X-Request-ID": uuidv4(),
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
  }
}
